import React from "react";
import { useNavigate } from "react-router-dom";
import { closeModal } from "react-url-modal";
import { Modal, Button } from "@/components";
import styles from "./SuccessCreateTournamentModal.module.scss";
import successRequestSendIcon from "@/assets/img/successRequestSend.svg";
import { useCurrentWidth } from "@/hooks";
import { MediaBreakPoints } from "@/resources/constants";

interface SuccessCreateTournamentModalProps {
  setIsOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  params?: Record<string, any>;
}

const TITLE = "Турнир успешно создан!";
const SUBTITLE =
  "Когда будут откликаться пользователи, Вам будут приходить уведомления на почту, указанную в профиле. Посмотреть контакты откликнувшихся пользователей можно в Вашем турнире.";

const SuccessCreateTournamentModalComponent = ({
  setIsOpen,
  params = {},
}: SuccessCreateTournamentModalProps): JSX.Element => {
  const navigate = useNavigate();
  const windowWidth = useCurrentWidth();
  const isMobile = windowWidth <= MediaBreakPoints.DESKTOP;

  const handleClose = () => {
    closeModal();
    navigate("/padel/tournaments/my");
    if (setIsOpen) {
      setIsOpen(false);
    }
  };

  return (
    <Modal
      title={TITLE}
      subTitle={SUBTITLE}
      isOpen={true}
      setIsOpen={setIsOpen || (() => {})}
      closeModal={handleClose}
      firmBack
    >
      <div className={styles.content}>
        <img
          src={successRequestSendIcon}
          alt="success create tournament"
          className={styles.image}
        />
        {
          isMobile && (
            <div className={styles.mobileContent}>
              <span className={styles.mobileTitle}>
                {TITLE}
              </span>
              <span className={styles.mobileSubTitle}>
                {SUBTITLE}
              </span>
            </div>
          )
        }
        <Button onClickFunc={handleClose} newStyles={styles.button}>
          Вернуться в "Мои турниры"
        </Button>
      </div>
    </Modal>
  );
};

export default SuccessCreateTournamentModalComponent;
export const SuccessCreateTournamentModal = SuccessCreateTournamentModalComponent;
